export const ausschreibungsdiensteFooterData = [
  {
    type: "FooterHeroColumn",
    title: "B_I ausschreibungs&shy;dienste",
    link: "/ausschreibungsdienste",
    youtube: "https://www.youtube.com/channel/UCojRk_tvvwegr0hZRYIhX-w",
    paragraph:
      "Öffentliche Ausschreibungen und private Aufträge aus ganz Deutschland einfach und schnell finden.",
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Unser Angebot",
    link: "/ausschreibungsdienste",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/ausschreibungen",
        label: "Alle Ausschreibungen",
      },
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/ausschreibungen/private-und-gewerbliche-auftraege-finden",
        label: "Private Aufträge finden",
      },
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/preise",
        label: "Preise vergleichen",
      },
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/teilnehmen",
        label: "An Vergaben teilnehmen",
      },
    ],
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Vergabe-Wissen",
    link: "/vergabe-wissen",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/vergabe-wissen/lexikon",
        label: "Fachbegriffe der Vergabe",
      },
      {
        type: "FooterLink",
        link: "/vergabe-wissen/news",
        label: "Aktuelle Nachrichten",
      },
      {
        type: "FooterLink",
        link: "/vergabe-wissen",
        label: "Kurs: Einführung ins Vergaberecht",
      },
    ],
  },
  {
    type: "FooterSpacerMobile",
  },
  {
    type: "FooterColumn",
    title: "Support",
    link: "/ausschreibungsdienste/support",
    paragraph: "",
    column_items: [
      {
        type: "FooterLink",
        link: "/ausschreibungsdienste/support",
        label: "Zum Helpcenter",
      },
      {
        type: "FooterLink",
        link: "/evergabe/support/veroeffentlichen",
        label: "Bekanntmachung veröffentlichen",
      },
    ],
  },
]
